import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";

export default function App() {
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={10}
      navigation={true}
      modules={[Navigation, Pagination]}
      breakpoints={{
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      }}
      className="mySwiper"
    >
      <SwiperSlide className="casino-slider-card casino-slider-cardNew">
        <div className="casino-slider-card-content">
          <img
            src={require("../../image/casino_game/gaming-icon.webp")}
            alt="Provably Fair Gaming"
          />
          <h3> Provably Fair Gaming</h3>
          <p>
            This feature allows players to verify the fairness of each game
            outcome, building trust and transparency.
          </p>
        </div>
      </SwiperSlide>
      <SwiperSlide className="casino-slider-card casino-slider-cardNew">
        <div className="casino-slider-card-content">
          <img
            src={require("../../image/casino_game/withdrawal-icon.webp")}
            alt="Instant Withdrawals"
          />
          <h3> Instant Withdrawals</h3>
          <p>
            Players can withdraw their winnings instantly, thanks to the fast
            transaction speeds of cryptocurrencies.
          </p>
        </div>
      </SwiperSlide>
      <SwiperSlide className="casino-slider-card casino-slider-cardNew">
        <div className="casino-slider-card-content">
          <img
            src={require("../../image/casino_game/anonymity-icon.webp")}
            alt="Anonymity"
          />
          <h3>Anonymity</h3>
          <p>
            Players can enjoy a higher level of privacy, as cryptocurrency
            transactions do not require personal information.
          </p>
        </div>
      </SwiperSlide>
      <SwiperSlide className="casino-slider-card casino-slider-cardNew">
        <div className="casino-slider-card-content">
          <img
            src={require("../../image/casino_game/global-icon.webp")}
            alt="Global Accessibility"
          />
          <h3> Global Accessibility</h3>
          <p>
            Our games can be accessed by players from all over the world,
            without the restrictions imposed by traditional banking systems.
          </p>
        </div>
      </SwiperSlide>
      <SwiperSlide className="casino-slider-card casino-slider-cardNew">
        <div className="casino-slider-card-content">
          <img
            src={require("../../image/casino_game/bonus-icon.webp")}
            alt="Bonuses and Rewards"
          />
          <h3>Bonuses and Rewards</h3>
          <p>
            Our game offers various bonuses and rewards to incentivize players,
            including welcome bonuses, loyalty programs, and referral rewards.
          </p>
        </div>
      </SwiperSlide>
      <SwiperSlide className="display_none_slider"></SwiperSlide>
    </Swiper>
  );
}
